import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function NotFound() {
    return (
        <Box
            sx={{
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                textAlign: 'center',
                padding: 3,
            }}
        >
            <Typography variant="h3" component="h1" children="404" />
            <Typography variant="h6" children="Page introuvable" />
            <Typography variant="body1" sx={{ maxWidth: 480 }} children="La page demandée n'existe pas ou a été déplacée." />

            <Button component={RouterLink} to="/" color='warning' children="Retour à l'accueil" />                
        </Box>
    );
}
